import React, { Component } from 'react';

// Externals
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Line } from 'react-chartjs-2';

// Material helpers
import { withStyles } from '@material-ui/core';

// Shared components
import {
  Portlet,
  PortletHeader,
  PortletLabel,
  PortletContent
} from 'components';

// Chart configuration
import { options } from './chart';

// Component styles
import styles from './styles';


class TrendChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
    }
  }

  render() {
    const { classes, className, title, ...rest } = this.props;
    const rootClassName = classNames(classes.root, className);
    let max = 10;
    this.props.data.datasets.forEach((dataset) => {
      max = Math.max(...dataset.data, max);
    });
    options.scales.yAxes[0].ticks.max = max;
    return (
      <Portlet
        {...rest}
        className={rootClassName}
      >
        <PortletHeader noDivider>
          <PortletLabel title={title} />
        </PortletHeader>
        <PortletContent>
          <div key={this.props.data} className={classes.chartWrapper}>
            <Line
              data={this.props.data}
              options={options}
            />
          </div>
        </PortletContent>
      </Portlet>
    );
  }
}

TrendChart.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(TrendChart);
